import { magnitudeDiff, softRound, OPTIONS } from "aible";
export default function getRange(min, max, offset = false, minimumSigFigs = 2) {
    let retMax = max;
    let retMin = min;
    if (max < min) {
        retMin = max;
        retMax = min;
    }
    const diff = retMax - retMin;
    if (offset) {
        const retDiff = 0.1 * Math.abs(diff);
        if (retMax < 0 && retMax + retDiff >= 0) {
            retMax = 0;
        }
        else {
            retMax = retMax + retDiff;
        }
        if (retMin > 0 && (retMin - retDiff <= 0 || retMin < diff)) {
            retMin = 0;
        }
        else {
            retMin = retMin - retDiff;
        }
    }
    const minSigFig = Math.max(Math.abs(magnitudeDiff(retMin, diff)) + 1, minimumSigFigs);
    const maxSigfig = Math.max(Math.abs(magnitudeDiff(retMax, diff)) + 1, minimumSigFigs);
    const roundedMin = softRound(retMin, {
        round: OPTIONS.softRound.FLOOR,
        sigFigs: minSigFig
    });
    const roundedMax = softRound(retMax, {
        round: OPTIONS.softRound.CEIL,
        sigFigs: maxSigfig
    });
    return [roundedMin, roundedMax];
}
